import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getShowCoreUpsell } from '../../../selectors/users';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props } from './BadgesSpotlightBox';

type StateProps = Pick<Props, 'isCurrentUserCoreMember' | 'showCoreUpsell'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => ({
  isCurrentUserCoreMember: getCurrentUserHasCore(state),
  showCoreUpsell: getShowCoreUpsell(state),
});

export default connect(mapStateToProps);
